import script from "./ServicePolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicePolicy.vue?vue&type=script&setup=true&lang=js"

import "./ServicePolicy.vue?vue&type=style&index=0&id=37838c9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37838c9c"]])

export default __exports__